<!--
 * @Descripttion: 
 * @Author: qixiao
 * @Date:2022-5-26 09:46:59
 * @LastEditors: liushumin
 * @LastEditTime: 2023-04-11 18:44:43
-->
<template>
  <div class="apps">
    <div class="hrs"></div>
    <el-main>
      <div class="top-wrap">
        <Bread></Bread>
      </div>
      <div class="main" id="main">
        <div class="soil-box">
          <div class="box-top">
            <span class="h1-top">{{ realData.deviceName }}</span>
            <span class="span-top"
              >设备序列号：<span>{{ realData.deviceCode }}</span>
            </span>
          </div>

          <div class="real-time">
            <span class="h1-real"
              ><img
                src="@/assets/agricultural/agrfont/icon_shishishuju.png"
                alt=""
              />
              实时数据</span
            >
            <span class="span-real" v-if="edition == 4"
              >最后数据上报时间：<span>{{ responseTime }}</span>
            </span>
            <span class="span-real" v-else
              >最后数据上报时间：<span>{{ real.sendTime }}</span>
            </span>
          </div>
          <div class="all-price" v-if="edition == 4">
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_turangwendu_da.png"
                  alt=""
                /><span class="abs-fs">土壤温度</span></span
              >
              <div class="p-price">
                <p v-if="soilV4temData">
                  <span>{{ soilV4temData }}</span
                  >℃
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_turangshidu_da.png"
                  alt=""
                /><span class="abs-fs">土壤湿度</span></span
              >
              <div class="p-price">
                <p v-if="soilV4humData">
                  <span>{{ soilV4humData }}</span
                  >%RH
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_daodianlv_da.png"
                  alt=""
                /><span class="abs-fs">电导率</span></span
              >
              <div class="p-price">
                <p v-if="soilV4ConData">
                  <span>{{ soilV4ConData }}</span
                  >μS/cm
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_turangyanfen_da.png"
                  alt=""
                /><span class="abs-fs">土壤盐分</span></span
              >
              <div class="p-price">
                <p v-if="soilV4SaltData">
                  <span>{{ soilV4SaltData }}</span
                  >μS/cm
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_phzhi_da.png"
                  alt=""
                /><span class="abs-fs">土壤PH值</span></span
              >
              <div class="p-price">
                <p>
                  <span>-</span>
                </p>
              </div>
            </div>
          </div>
          <div class="all-price" v-else>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_turangwendu_da.png"
                  alt=""
                /><span class="abs-fs">土壤温度</span></span
              >
              <div class="p-price">
                <p v-if="real.wirelessTempData">
                  <span>{{ real.wirelessTempData }}</span
                  >℃
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_turangshidu_da.png"
                  alt=""
                /><span class="abs-fs">土壤湿度</span></span
              >
              <div class="p-price">
                <p v-if="real.wirelessHumidityData">
                  <span>{{ real.wirelessHumidityData }}</span
                  >%RH
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_daodianlv_da.png"
                  alt=""
                /><span class="abs-fs">电导率</span></span
              >
              <div class="p-price">
                <p v-if="real.wirelessConductivityData">
                  <span>{{ real.wirelessConductivityData }}</span
                  >μS/cm
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_turangyanfen_da.png"
                  alt=""
                /><span class="abs-fs">土壤盐分</span></span
              >
              <div class="p-price">
                <p v-if="real.wirelessSalinityData">
                  <span>{{ real.wirelessSalinityData }}</span
                  >μS/cm
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
            <div class="div-price">
              <span class="span-price"
                ><img
                  src="@/assets/agricultural/agrfont/icon_phzhi_da.png"
                  alt=""
                /><span class="abs-fs">土壤PH值</span></span
              >
              <div class="p-price">
                <p v-if="real.wirelessPhData">
                  <span>{{ real.wirelessPhData }}</span>
                </p>
                <p v-else>
                  <span>-</span>
                </p>
              </div>
            </div>
          </div>
          <div class="dialogBox" id="box-center">
            <div class="dialogTitle">
              <img
                src="@/assets/agricultural/agrfont/icon_lishishuju.png"
                alt=""
              />
              历史数据
            </div>
            <div class="queryBox" id="time-center">
              <el-button
                @click="timeClick(1)"
                :style="
                  btnActive === 1
                    ? 'color: #fff;background-color: #018388 ;border:1px solid #018388;'
                    : ''
                "
                >近7天</el-button
              >
              <el-button
                @click="timeClick(2)"
                :style="
                  btnActive === 2
                    ? 'color: #fff;background-color: #018388 ;border:1px solid #018388;'
                    : ''
                "
                >近1个月</el-button
              >
              <el-date-picker
                v-model="timeVal"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="dateChange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
            <div class="echarts_tree">
              <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_turangwendu_da.png"
                    alt=""
                  />
                  <span>土壤温度（℃）</span>
                </p>
                <div
                  id="chart1"
                  style="width: 95%; height: 240px"
                  v-show="realAll_Temp.flat || realAll_Temp.vert"
                ></div>
                <div
                  class="null-Soil"
                  v-show="!realAll_Temp.flat || !realAll_Temp.vert"
                >
                  暂无数据
                </div>
              </div>
              <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_turangshidu_da.png"
                    alt=""
                  />
                  <span>土壤湿度（%RH）</span>
                </p>
                <div
                  id="chart2"
                  style="width: 95%; height: 240px"
                  v-show="realAll_Humidity.flat || realAll_Humidity.vert"
                ></div>
                <div
                  class="null-Soil"
                  v-show="!realAll_Humidity.flat || !realAll_Humidity.vert"
                >
                  暂无数据
                </div>
              </div>
              <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_daodianlv_da.png"
                    alt=""
                  />
                  <span>电导率（μS/cm）</span>
                </p>
                <div
                  id="chart3"
                  style="width: 95%; height: 240px"
                  v-show="
                    realAll_Conductivity.flat || realAll_Conductivity.vert
                  "
                ></div>
                <div
                  class="null-Soil"
                  v-show="
                    !realAll_Conductivity.flat || !realAll_Conductivity.vert
                  "
                >
                  暂无数据
                </div>
              </div>
              <div class="echarts_tree_top">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_turangyanfen_da.png"
                    alt=""
                  />
                  <span>土壤盐分（μS/cm）</span>
                </p>
                <div
                  id="chart4"
                  style="width: 95%; height: 240px"
                  v-show="realAll_Salinity.flat || realAll_Salinity.vert"
                ></div>
                <div
                  class="null-Soil"
                  v-show="!realAll_Salinity.flat || !realAll_Salinity.vert"
                >
                  暂无数据
                </div>
              </div>
              <!-- <div class="echarts_tree_top" v-if="realAll_Ph.flat.length>0 || realAll_Ph.vert.length>0">
                <p>
                  <img
                    src="@/assets/agricultural/agrfont/icon_phzhi_da.png"
                    alt=""
                  />
                  <span>土壤PH值 </span>
                </p>
                <div
                  id="chart5"
                  style="width: 95%; height: 240px"
                ></div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
export default {
  name: "AgrMonitoringSoil",
  data() {
    return {
      deviceTypeId: "",
      btnActive: 1,
      timeVal: "",
      real: {},
      realAll_Temp: {
        //土壤温度
        flat: [],
        vert: [],
      },
      realAll_Humidity: {
        //土壤湿度
        flat: [],
        vert: [],
      },
      realAll_Conductivity: {
        //电导率
        flat: [],
        vert: [],
      },
      realAll_Salinity: {
        //土壤盐分
        flat: [],
        vert: [],
      },
      realAll_Ph: {
        //土壤ph值
        flat: [],
        vert: [],
      },
      realData: {
        deviceCode: "-",
        deviceName: "-",
      },
      soilV4temData: "",
      soilV4humData: "",
      soilV4SaltData: "",
      soilV4ConData: "",
      edition: "",
      responseTime: "",
    };
  },
  mounted() {},
  created() {
    this.getRealSoilDate();
    this.getRealSoilDateAll();
  },
  methods: {
    // 土壤实时数据
    getRealSoilDate() {
      let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
      this.edition = farmAllData.edition;
      this.realData = {
        deviceCode: farmAllData.deviceCode,
        deviceName: farmAllData.deviceName,
      };
      let obj = { sensorNum: this.realData.deviceCode };
      if (this.edition != 4) {
        this.$http.agrModel.getRealSoil(obj).then((res) => {
          console.log(res);
          if (res.status === "1") {
            this.real = res.data;
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      } else {
        this.$http.nqMonitor
          .monitorGroupV4({ imei: farmAllData.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              this.responseTime = res.data.result[0].sendTime;
              if (res.data.result && res.data.result.length > 0) {
                let soilV4DataList = res.data.result;
                var that = this;
                soilV4DataList.forEach((val) => {
                  // B1土壤温度
                  if (val.sensorType && val.sensorType == "B1") {
                    that.soilV4temData = val.sensorData;
                  }
                  // B2土壤湿度
                  if (val.sensorType && val.sensorType == "B2") {
                    that.soilV4humData = val.sensorData;
                  }
                  // B3土壤盐分
                  if (val.sensorType && val.sensorType == "B3") {
                    that.soilV4SaltData = val.sensorData;
                  }
                  // B4土壤电导率
                  if (val.sensorType && val.sensorType == "B4") {
                    that.soilV4ConData = val.sensorData;
                  }
                });
                this.deviceStatus = "设备正常";
              } else {
                this.soilV4temData = "";
                this.soilV4humData = "";
                this.soilV4SaltData = "";
                this.soilV4ConData = "";
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      }
    },
    // 土壤历史数据
    getRealSoilDateAll(data) {
      let time = "";
      let timeArr = [];
      let currentDay = false;
      if (this.btnActive === 1) {
        time = "w";
      } else if (this.btnActive === 2) {
        time = "m";
      } else {
        timeArr = data;
        if (this.timeVal && this.timeVal[0] != "" && this.timeVal[1] != "") {
          if (this.timeVal[0] == this.timeVal[1]) {
            currentDay = true;
          }
        }
      }
      let obj = {
        sensorNum: this.realData.deviceCode,
        type: time,
        startTime: timeArr[0],
        endTime: timeArr[1],
      }; //类型；w 最近七天；m 最近30天
      if (this.edition != 4) {
        this.$http.agrModel.getRealSoilAll(obj).then((res) => {
          console.log(res);
          if (res.status === "1") {
            this.realAll_Temp.flat = res.data.Temp.flat;
            this.realAll_Temp.vert = res.data.Temp.vert;
            this.realAll_Humidity.vert = res.data.Humidity.vert;
            this.realAll_Humidity.flat = res.data.Humidity.flat;
            this.realAll_Conductivity.vert = res.data.Conductivity.vert;
            this.realAll_Conductivity.flat = res.data.Conductivity.flat;
            this.realAll_Salinity.vert = res.data.Salinity.vert;
            this.realAll_Salinity.flat = res.data.Salinity.flat;
            this.realAll_Ph.vert = res.data.Ph.vert;
            this.realAll_Ph.flat = res.data.Ph.flat;
            this.getEchartData1();
            this.getEchartData2();
            this.getEchartData3();
            this.getEchartData4();
            this.getEchartData5();
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      } else {
        this.$http.nqMonitor.monitorHisGroupV4(obj).then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            let echartsDatas = res.data.result;
            if (echartsDatas.length > 0) {
              var that = this;
              echartsDatas.forEach((item) => {
                if (item.sensorType && item.sensorType == "B1") {
                  let soilSaltMapList = item.list;
                  if (soilSaltMapList.length > 0) {
                    that.realAll_Temp.flat = [];
                    that.realAll_Temp.vert = [];
                    soilSaltMapList.forEach((its) => {
                      that.realAll_Temp.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Temp.vert.push(its.sensorData);
                      } else {
                        that.realAll_Temp.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "B2") {
                  let soilConductivityDataMapList = item.list;
                  if (soilConductivityDataMapList.length > 0) {
                    that.realAll_Humidity.flat = [];
                    that.realAll_Humidity.vert = [];
                    soilConductivityDataMapList.forEach((its) => {
                      that.realAll_Humidity.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Humidity.vert.push(its.sensorData);
                      } else {
                        that.realAll_Humidity.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "B3") {
                  let soilSaltMapList = item.list;
                  if (soilSaltMapList.length > 0) {
                    that.realAll_Salinity.flat = [];
                    that.realAll_Salinity.vert = [];
                    soilSaltMapList.forEach((its) => {
                      that.realAll_Salinity.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Salinity.vert.push(its.sensorData);
                      } else {
                        that.realAll_Salinity.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "B4") {
                  let soilConductivityDataMapList = item.list;
                  if (soilConductivityDataMapList.length > 0) {
                    that.realAll_Conductivity.flat = [];
                    that.realAll_Conductivity.vert = [];
                    soilConductivityDataMapList.forEach((its) => {
                      that.realAll_Conductivity.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Conductivity.vert.push(its.sensorData);
                      } else {
                        that.realAll_Conductivity.vert.push(its.avgVal);
                      }
                    });
                  }
                }
              });
            } else {
              this.realAll_Temp.flat = [];
              this.realAll_Temp.vert = [];
              this.realAll_Humidity.flat = [];
              this.realAll_Humidity.vert = [];
              this.realAll_Conductivity.flat = [];
              this.realAll_Conductivity.vert = [];
              this.realAll_Salinity.flat = [];
              this.realAll_Salinity.vert = [];
            }
            this.getEchartData1();
            this.getEchartData2();
            this.getEchartData3();
            this.getEchartData4();
            this.getEchartData5();
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      }
    },
    // getEchartData函数都为 图表
    getEchartData1() {
      const chart1 = document.getElementById("chart1");
      var _that = this;
      if (chart1) {
        const myChart = this.$echarts.init(chart1);
        const option = {
          tooltip: {
            trigger: "axis",

            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "土壤温度（℃）" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
            areaStyle: {
              itemStyle: {
                normal: {
                  color: "#3FE1E7",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: _that.realAll_Temp.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: _that.realAll_Temp.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData2() {
      const chart2 = document.getElementById("chart2");
      if (chart2) {
        const myChart = this.$echarts.init(chart2);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "土壤湿度（%RH）" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
          },
          areaStyle: {
            itemStyle: {
              normal: {
                color: "#3FE1E7",
                lineStyle: {
                  color: "#3FE1E7",
                },
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#cff7f9", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#cff7f9", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,

            data: this.realAll_Humidity.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: this.realAll_Humidity.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData3() {
      const chart3 = document.getElementById("chart3");
      if (chart3) {
        const myChart = this.$echarts.init(chart3);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "电导率（μS/cm）" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
          },
          areaStyle: {
            itemStyle: {
              normal: {
                color: "#3FE1E7",
                lineStyle: {
                  color: "#3FE1E7",
                },
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#cff7f9", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#cff7f9", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.realAll_Conductivity.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: this.realAll_Conductivity.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData4() {
      const chart4 = document.getElementById("chart4");
      if (chart4) {
        const myChart = this.$echarts.init(chart4);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "土壤盐分（μS/cm）" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
          },
          areaStyle: {
            itemStyle: {
              normal: {
                color: "#3FE1E7",
                lineStyle: {
                  color: "#3FE1E7",
                },
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#cff7f9", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#cff7f9", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.realAll_Salinity.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: this.realAll_Salinity.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData5() {
      const chart5 = document.getElementById("chart5");
      if (chart5) {
        const myChart = this.$echarts.init(chart5);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "土壤PH值" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
          },
          areaStyle: {
            itemStyle: {
              normal: {
                color: "#3FE1E7",
                lineStyle: {
                  color: "#3FE1E7",
                },
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#cff7f9", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#cff7f9", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.realAll_Ph.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: this.realAll_Ph.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    timeClick(num) {
      this.timeVal = "";
      this.btnActive = num;
      if (num === 1) {
        this.getRealSoilDateAll("w");
      } else if (num === 2) {
        this.getRealSoilDateAll("m");
      }
      {
      }
    },
    dateChange(val) {
      if (val && val[0]) {
        this.btnActive = 3;
      }
      this.getRealSoilDateAll(val);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.apps {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  margin: 0;
  padding: 0;

  .soil-box {
    width: 100%;
    height: 100%;

    .box-top {
      position: relative;
      height: 3vh;

      .h1-top {
        font-size: 22px;
        color: #333;
        margin-right: 4vh;
        font-weight: 700;
      }

      .span-top {
        font-size: 16px;
        margin-right: 4vh;
        color: #888;
      }

      .span-go {
        position: absolute;
        right: 5vh;
        top: 1vh;
        font-size: 16px;
        text-align: right;
        cursor: pointer;
        color: #018388;

        i {
          font-size: 16px;
          margin-right: 0.5vh;
        }
      }
    }

    .real-time {
      height: 30px;
      margin-top: 30px;
      color: #018388;
      overflow-x: auto;

      .h1-real {
        font-size: 18px;
        margin-right: 2vh;
        font-weight: 700;
      }

      .span-real {
        font-size: 16px;
        margin-right: 4vh;
        margin-left: 1.2vh;
      }

      img {
        height: 18px;
        vertical-align: bottom;
        margin-bottom: 2px;
      }
    }

    .all-price {
      margin-top: 2vh;
      margin-bottom: 1vh;
      box-sizing: border-box;
      height: 110px;
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      justify-content: space-between;

      .p-price {
        margin-left: 3vh;
        display: inline-block;
        position: relative;

        p {
          position: absolute;
          top: -5vh;
          font-weight: 400;
          color: #444;
          font-size: 2.1vh;
        }
      }

      .div-price {
        width: 19%;
        height: 100%;
        box-sizing: border-box;
        padding: 20px 0;
        text-align: center;
        // padding-left: -2vh;
        margin-right: 10px;

        display: inline-block;
        background-color: #f4faf9;

        .span-price {
          display: inline-block;
          height: 100%;
          margin-left: -4vw;

          .abs-fs {
            font-weight: 600;
            font-size: 16px;
            color: #018388;
          }

          img {
            display: block;
            height: 40px;
            text-align: center;
            margin: 0 auto;
            margin-bottom: 1.5vh;
          }
        }
      }
    }
  }

  #box-center {
    margin-top: 2vh;
    height: 100%;

    .dialogTitle {
      font-size: 18px;
      margin-right: 2vh;
      font-weight: 700;
      margin-bottom: 2vh;
      color: #018388;

      img {
        height: 18px;
        vertical-align: bottom;
        margin-bottom: 2px;
      }
    }

    .time-center {
      width: 100%;
    }

    ::v-deep .el-date-editor.el-input__inner {
      width: 30%;
      margin-left: 2vh;
    }

    ::v-deep .el-input__inner {
      height: 37px;
    }

    .echarts_tree {
      margin-top: 2vh;

      .echarts_tree_top {
        width: 50%;
        float: left;

        .null-Soil {
          text-align: center;
          height: 240px;
          line-height: 240px;
        }

        p {
          margin-bottom: 10px;

          img {
            height: 18px;
            vertical-align: middle;
          }

          span {
            font-size: 16px;
            margin-left: 1vh;
            vertical-align: middle;
          }
        }
      }
    }

    .bg-bai {
      border: 1px soild;
      color: #018388;
      background-color: #e6f3f3;
    }
  }

  .hrs {
    position: absolute;
    top: 120px;
    left: 2vh;
    width: 98%;
    height: 1px;
    background-color: #efefef;
  }
}
</style>
